<ng-container ngForm>
  @if (parameters) {
    <sharing-parameters
      ngModelGroup="parameters"
      [expandAll]="true"
      [model]="parameters"
      (change)="onParametersChange()"
      [showLinkType]="shouldShowLinkType"
    />
  }
</ng-container>
